import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

export interface Lookup {
  id: number;
  sequenceNo: number;
  type: string;
  name: string;
}
export interface SubAreaProps {
  id: number;
  areaId: number;
  subAreaName: string;
  subAreaDisplayName: string;
}

export interface StateProps {
  id: number;
  regionId: number;
  stateName: string;
  stateDisplayName: string;
}

export interface RegionProps {
  id: number;
  countryId: number;
  regionName: string;
  regionDisplayName: string;
}

export interface AreaProps {
  id: number;
  stateId: number;
  areaName: number;
  areaDisplayName: string;
}

export interface CourseProps {
  id: number;
  productId: number;
  courseName: string;
  courseDescription: string;
  value: number;
  label: string;
}

let initialState: any = {
  commonResponse: {},
};

//Get User Role API call
export const CommonService = createAsyncThunk(
  "master/common",
  async (common: any) => {
    try {
      let response;
      switch (common.apiAction) {
        case "School":
          response = await getAPI(CommonEndpoint.school);
          break;
        case "AddSchool":
          response = await postAPI(CommonEndpoint.school, common?.schoolName);
          break;
        case "Country":
          response = await getAPI(CommonEndpoint.country);
          break;
        case "State":
          response = await getAPI(
            `${CommonEndpoint.state}${appendQueryStr(common?.ids, "regionIds")}`
          );
          break;
        case "Region":
          response = await getAPI(CommonEndpoint.region);
          break;
        case "Area":
          response = await getAPI(
            `${CommonEndpoint.area}${appendQueryStr(common.ids, "stateIds")}`
          );
          break;
        case "SubArea":
          response = await getAPI(
            `${CommonEndpoint.subArea}${appendQueryStr(common.ids, "areaIds")}`
          );
          break;

        case "Course":
          response = await getAPI(CommonEndpoint.course);
          break;
        case "CourseLevel":
          response = await getAPI(
            `${CommonEndpoint.courseLevel}/${common.courseId}/${CommonEndpoint.courseLevel}`
          );
          break;
        case "Lookup":
          response = await getAPI(
            `${CommonEndpoint.lookup}${appendQueryStr(common.lookup, "types")}`
          );
          break;
        case "loginImage":
          response = await getAPI(`${CommonEndpoint.downloadLoginGif}`);
          break;
        case "downloadMyProfile":
          response = await getAPI(
            `${CommonEndpoint.downlodMyprofile}/${common?.id}`
          );
          break;
        case "fileDelete":
          response = await getAPI(
            `${CommonEndpoint.fileDelete}/${common.fileName}`
          );
          break;
          case "logout":
          response = await postAPI(CommonEndpoint.logout, common?.requestData);
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const appendQueryStr = (ids: number[], name: string) => {
  let qeryStr = "";
  if (ids && ids.length) {
    for (let i = 0; i < ids.length; i++) {
      if (i === 0) {
        qeryStr += `?${name}=${ids[i]}`;
      } else {
        qeryStr += `&${name}=${ids[i]}`;
      }
    }
  }
  return qeryStr;
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(CommonService.fulfilled, (state, action) => {
      state.commonResponse = action.payload;
    });
    builder.addCase(CommonService.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const commonReducer = commonSlice.reducer;
export default commonReducer;
